import { PushpinFilled, PushpinOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import { getOperationName } from 'apollo-link'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { GetViewerFollowingGroupsDocument, useGroupPinUpdateMutation } from '@/generated/graphql'

interface PinProps {
  groupId: number
  isPinned: boolean
}

export const Pin: React.FC<PinProps> = ({ groupId, isPinned }) => {
  const [t] = useTranslation()

  const [usePin] = useGroupPinUpdateMutation({
    refetchQueries: [getOperationName(GetViewerFollowingGroupsDocument)!],
  })

  const thePin = (
    <Tooltip title={t(`group.${isPinned ? 'cancelQuickAccess' : 'quickAccess'}`)}>
      <span
        onClick={(e) => {
          e.stopPropagation()
          usePin({ variables: { groupId } })
        }}
      >
        {isPinned ? <PushpinFilled /> : <PushpinOutlined />}
      </span>
    </Tooltip>
  )

  return thePin
}
